import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  getQuizzesAsDataTable,
  createNewQuiz,
  editQuiz,
  // changeQuizPublishState,
} from './thunks';
import { QuizzesState } from './types';

export const name = 'quizzes';

const initialState: QuizzesState = {
  dataTable: {
    data: null,
    status: 'idle',
  },
  create: {
    status: 'idle',
  },
  update: {
    status: 'idle',
  },
  // changePublishState: {
  //   status: 'idle',
  // },
};

export const getQuizzesAsDataTableAsync = createAsyncThunk(
  name + '/getQuizzesAsDataTable',
  getQuizzesAsDataTable
);

export const createNewQuizAsync = createAsyncThunk(
  name + '/createNewQuiz',
  createNewQuiz
);

export const editQuizAsync = createAsyncThunk(name + '/editQuiz', editQuiz);

// export const changeQuizPublishStateAsync = createAsyncThunk(
//   name + '/changeQuizPublishState',
//   changeQuizPublishState
// );

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
    clearDataTableData: (state) => {
      state.dataTable.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuizzesAsDataTableAsync.pending, (state) => {
        state.dataTable.status = 'loading';
      })
      .addCase(getQuizzesAsDataTableAsync.fulfilled, (state, action) => {
        state.dataTable = {
          data: action.payload,
          status: 'idle',
        };
      })
      .addCase(getQuizzesAsDataTableAsync.rejected, (state) => {
        state.dataTable.status = 'failed';
      })
      .addCase(createNewQuizAsync.pending, (state) => {
        state.create.status = 'loading';
      })
      .addCase(createNewQuizAsync.fulfilled, (state) => {
        state.create.status = 'idle';
      })
      .addCase(createNewQuizAsync.rejected, (state) => {
        state.create.status = 'failed';
      })
      .addCase(editQuizAsync.pending, (state) => {
        state.update.status = 'loading';
      })
      .addCase(editQuizAsync.fulfilled, (state) => {
        state.update.status = 'idle';
      })
      .addCase(editQuizAsync.rejected, (state) => {
        state.update.status = 'failed';
      });
    // .addCase(changeQuizPublishStateAsync.pending, (state) => {
    //   state.changePublishState.status = 'loading';
    // })
    // .addCase(changeQuizPublishStateAsync.fulfilled, (state) => {
    //   state.changePublishState.status = 'idle';
    // })
    // .addCase(changeQuizPublishStateAsync.rejected, (state) => {
    //   state.changePublishState.status = 'failed';
    // });
  },
});

export const actions = slice.actions;

export default slice.reducer;
